import React, { useEffect, useState } from 'react'
import { getTodosFichajes, getTodosFichajesDescarga, getTrabajadores } from '../../services/apis';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SelectorMes } from '../../utils/componentes-utiles/SelectorMes';
import { exportarExcel, formatTime, mesName } from '../../utils/utils';
import { SelectorYear } from '../../utils/componentes-utiles/SelectorYear';
import DownloadIcon from '@mui/icons-material/Download';
import { AlertError } from '../../utils/componentes-utiles/AlertError';
import { BarrasHorasSemanaEmpleado } from '../../utils/componentes-utiles/graficas/BarrasHorasSemanaEmpleado';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AutocompleteList from '../../utils/componentes-utiles/AutocompleteList';
import { DialogHorasInvertidas } from '../fichaje/DialogHorasInvertidas';
import AuditoriaFichajesDialog from '../fichaje/AuditoriaFichajes';
import { DialogDescargaFichajes } from '../fichaje/DialogDescargaFichajes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BarrasHorasInvertidasHorizontalesDia } from '../../utils/componentes-utiles/graficas/BarrasHorasInvertidasHorizontalesDia';

export const HorasInvertidasEnTareas = () => {

    const [fichajes, setFichajes] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [nombreMes, setNombreMes] = useState(mesName(mes));
    const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);
    const [open, setOpen] = useState(false);
    const [dialogDescarga, setDialogDescarga] = useState(false);
    const [auditoria, setAuditoria] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [opcionesUsuarios, setOpcionesUsuarios] = useState([]);
    const [loadedFilters, setLoadedFilters] = useState(false);
    const [dialogHorasInvertidas, setDialogHorasInvertidas] = useState(false);
    const [filtros, setFiltros] = useState({ fechaDesde: '', fechaHasta: '' });
    const [datosFichajeSeleccionado, setDatosFichajeSeleccionado] = useState(null);

    useEffect(() => {
        const fechaDesde = `${yearSelected}-${String(mes).padStart(2, '0')}-01`;
        const lastDay = new Date(yearSelected, mes, 0).getDate();
        const fechaHasta = `${yearSelected}-${String(mes).padStart(2, '0')}-${lastDay}`;

        setFiltros({ fechaDesde, fechaHasta });
        setNombreMes(mesName(mes));
        setLoadedFilters(false);
    }, [mes, yearSelected]);

    useEffect(() => {
        if (filtros.fechaDesde && filtros.fechaHasta) {
            setLoadedFilters(false);

            consultarFichaje();
        }
    }, [filtros, selectedUsers]);

    useEffect(() => {
        cargarTrabajadores();
    }, []);


    const dias = ["Empleado", "Horas de este Mes", "Horas empleadas en tareas este mes", " "];

    const Navigate = useNavigate();

    // const obtenersoloFechaActual = () => {
    //     const now = new Date(); // Obtiene la fecha y hora actual
    //     const year = now.getFullYear(); // Obtiene el año
    //     const month = String(now.getMonth() + 1).padStart(2, '0'); // Obtiene el mes (añade 1 porque los meses van de 0 a 11)
    //     const day = String(now.getDate()).padStart(2, '0'); // Obtiene el día del mes

    //     // Devuelve la fecha en el formato "YYYY-MM-DD HH:MM:SS"
    //     return `${yearSelected}-${month}-${day}`;
    // };
    const consultarFichaje = async () => {
        try {
            const usuarioIds = selectedUsers.map(u => u.value); // Extrae solo los IDs
            const response = await getTodosFichajes(filtros.fechaDesde, filtros.fechaHasta, usuarioIds);
            setFichajes(response.data.fichajes);
            setYears(response.data.years);
            setLoaded(true);
            setLoadedFilters(true);
        } catch (error) {
            console.error("Error al consultar los fichajes:", error);
        }
    };

    // function formatTime(segundos) {
    //     const horas = Math.floor(segundos / 3600);
    //     const minutos = Math.floor((segundos % 3600) / 60);
    //     const seg = segundos % 60;
    //     return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(seg).padStart(2, '0')}`;
    // }

    const descargarFichajesDelMes = async () => {


        try {
            const response = await getTodosFichajesDescarga(mes, yearSelected);

            const fichajes = response.data.fichajes;

            const exportar = exportarExcel(fichajes, `fichajes_${mes}_${yearSelected}`);
            if (exportar) {
                console.log("exportado");


            } else {
                console.log("no exportado");
                setOpen(true);
            }
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }


    }
    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores(); // Asegúrate de tener esta función en apis.js
            const opciones = response.data.map(item => ({
                label: item.nombre,
                value: item.id
            }));
            setOpcionesUsuarios(opciones);
        } catch (error) {
            console.error("Error al cargar trabajadores", error);
        }
    };
    useEffect(() => {
        // consultarFichaje();
        setNombreMes(mesName(mes));

    }, []);
    useEffect(() => {
        if (mes && yearSelected) {
            const fechaDesde = `${yearSelected}-${String(mes).padStart(2, '0')}-01`;
            const lastDay = new Date(yearSelected, mes, 0).getDate();
            const fechaHasta = `${yearSelected}-${String(mes).padStart(2, '0')}-${lastDay}`;
            setFiltros({ fechaDesde, fechaHasta });
            setNombreMes(mesName(mes));
        }
    }, [mes, yearSelected]);


    const obtenerFechaCompleta = (diaTexto) => {
        const match = diaTexto.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
        if (!match) return diaTexto;
        const dia = parseInt(match[1], 10);
        const mes = parseInt(match[2], 10) - 1;
        const hoy = new Date();
        const fecha = new Date(hoy.getFullYear(), mes, dia);

        const diasLargos = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const mesesLargos = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

        return `${diasLargos[fecha.getDay()]} ${fecha.getDate()} de ${mesesLargos[fecha.getMonth()]}`;
    };
    const convertirHoras = (horas) => {
        const h = Math.floor(horas);
        const m = Math.round((horas - h) * 60);
        return `${h}h${m > 0 ? ` ${m}min` : ''}`;
    };
    return (
        <Grid container direction={'row'} alignItems={'start'} justifyContent={'center'} xs={12}>
            <SubHeader />
            <div className='menu-principal fade-in-2'>
                {!loaded && (<CircularProgress />)}
                {loaded && (
                    <>
                        <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'} xs={12}>
                            <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'} xs={11.5} md={12}>
                                <Grid container direction={'row'} marginBottom={"0.5em"} alignItems={'center'} justifyContent={'center'} xs={12} gap={1} >
                                    <Grid container xs={12} md={2} direction={'row'} justifyContent={'start'} alignItems={'start'}>
                                        <h3>Fichajes de {nombreMes}</h3> &nbsp;<CircularProgress style={{ display: loadedFilters ? 'none' : 'block' }} />
                                    </Grid>

                                    <Grid container xs={6} md={2} gap={1} justifyContent={'center'} alignItems={'center'}>
                                        <TextField
                                            label="Desde"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            value={filtros.fechaDesde}
                                            onChange={(e) => setFiltros(prev => ({ ...prev, fechaDesde: e.target.value }))}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid container xs={6} md={2} gap={1} justifyContent={'center'} alignItems={'center'}>

                                        <TextField
                                            label="Hasta"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            value={filtros.fechaHasta}
                                            onChange={(e) => setFiltros(prev => ({ ...prev, fechaHasta: e.target.value }))}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid container xs={12} md={3} justifyContent={'center'} alignItems={'center'} style={{ marginTop: '-2.5em' }}>
                                        <AutocompleteList array={opcionesUsuarios} setArray={setSelectedUsers} label={"Seleccion uno o mas usuarios "} />
                                    </Grid>
                                </Grid>
                                {fichajes.length <= 0 && (
                                    <Grid container xs={12} justifyContent={'center'} alignItems={'center'}>
                                        <strong>Todavía no hay fichajes</strong>
                                    </Grid>
                                )}
                                {fichajes && fichajes.length >= 1 && (
                                    <>
                                        {fichajes.length > 0 && fichajes.map((usuario, i) => (
                                            <Accordion key={i} sx={{ width: '100%', my: 1 }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`usuario-${i}-content`}
                                                    id={`usuario-${i}-header`}
                                                >
                                                    <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
                                                        <Typography fontWeight={600}>{usuario.usuario}</Typography>
                                                        <Typography fontSize={14} color="textSecondary">
                                                            Total: {convertirHoras(usuario.horasSemana?.reduce((sum, dia) =>
                                                                sum + dia.tareas.reduce((suma, tarea) => suma + tarea.horas, 0), 0) || 0)}
                                                        </Typography>
                                                    </Box>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <DialogHorasInvertidas
                                                        open={dialogHorasInvertidas && datosFichajeSeleccionado?.usuario === usuario.usuario}
                                                        setOpen={setDialogHorasInvertidas}
                                                        data={usuario}
                                                    />

                                                    {/* Mostrar grafica resumida si se desea */}
                                                    {/* <Button variant="outlined" onClick={() => {
                                                        setDatosFichajeSeleccionado(usuario);
                                                        setDialogHorasInvertidas(true);
                                                    }}>
                                                        Ver detalle de horas invertidas
                                                    </Button> */}
                                                    {usuario?.horasSemana?.length > 0 ? (
                                                        usuario.horasSemana.map((dia, index) => {
                                                            const totalDia = dia.tareas.reduce((suma, tarea) => suma + tarea.horas, 0);
                                                            return dia.tareas.length > 0 && (
                                                                <Accordion key={index} style={{ marginBottom: '12px' }}>
                                                                    <AccordionSummary
                                                                        expandIcon={<ExpandMoreIcon />}
                                                                        aria-controls={`panel${index}-content`}
                                                                        id={`panel${index}-header`}
                                                                    >
                                                                        <Box>
                                                                            <Typography variant="subtitle1">
                                                                                {obtenerFechaCompleta(dia.dia)}
                                                                            </Typography>
                                                                            <Typography variant="caption" color="textSecondary">
                                                                                Total: {convertirHoras(totalDia)}
                                                                            </Typography>
                                                                        </Box>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails>
                                                                        <Box sx={{ overflowX: 'auto' }}>
                                                                            <BarrasHorasInvertidasHorizontalesDia data={dia.tareas} />
                                                                        </Box>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            );
                                                        })
                                                    ) : (
                                                        <Typography variant="body2" color="textSecondary">
                                                            No hay tareas registradas esta semana.
                                                        </Typography>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}

                                    </>

                                )}
                            </Grid>

                        </Grid>

                    </>

                )}
            </div >
        </Grid >
    );
}

